"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyAnimations = applyAnimations;
exports.applyGlobalAnimations = applyGlobalAnimations;
exports.applyTargetedAnimations = applyTargetedAnimations;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Sources = require("@studio/constants/Sources");
var _SceneLayouts = require("@studio/constants/SceneLayouts");
var _underscore = require("underscore");
var _utils = require("../utils");
var _animationUtils = require("./animationUtils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Apply animations based on current (outgoing) and next (incoming) scene.
 * @param {{}} currentScene
 * @param {{}} nextScene
 * @returns {{}}
 */
function applyTargetedAnimations(currentScene, nextScene) {
  if (currentScene && nextScene) {
    // When we're switching to a solo mode. We need to apply crossfade animation
    if ((0, _animationUtils.isSoloMedia)(nextScene) || (0, _animationUtils.isSoloCameraPresenter)(nextScene) || (0, _animationUtils.isSoloScreenPresenter)(nextScene)) {
      // It is possible this will return undefined
      var nextSoloSource = (0, _animationUtils.findSoloSource)(nextScene);

      // Only apply animation when solo source exist
      if (!!nextSoloSource) {
        var _nextSoloSource$layer, _nextSoloSource$sourc;
        var layerAnimation = ((_nextSoloSource$layer = nextSoloSource.layer) === null || _nextSoloSource$layer === void 0 ? void 0 : _nextSoloSource$layer.animation) || {};
        var sourceType = (_nextSoloSource$sourc = nextSoloSource.source) === null || _nextSoloSource$sourc === void 0 ? void 0 : _nextSoloSource$sourc.type;

        // Skip crossfade for media assets (images/PDFs/videos) to prevent flicker during asset load
        // For media assets, set initial opacity to 1 to prevent transparency during scene transition
        var isMedia = [_Sources.IMAGE_FILE, _Sources.PDF_FILE, _Sources.VIDEO_FILE].includes(sourceType);
        if (isMedia) {
          // Set initial and animate opacity to 1 for instant full visibility (no fade-in)
          var nextLayerAnimation = _objectSpread(_objectSpread({}, layerAnimation), {}, {
            initial: _objectSpread(_objectSpread({}, layerAnimation === null || layerAnimation === void 0 ? void 0 : layerAnimation.initial), {}, {
              opacity: 1 // Start fully visible, no fade-in
            }),
            animate: _objectSpread(_objectSpread({}, layerAnimation === null || layerAnimation === void 0 ? void 0 : layerAnimation.animate), {}, {
              opacity: 1
            }),
            transition: _objectSpread({}, _utils.HARD_CUT_ANIMATION.transition)
          });
          nextSoloSource.layer.animation = nextLayerAnimation;
          nextScene = (0, _animationUtils.replaceSource)(nextScene, nextSoloSource._id, nextSoloSource);
        } else {
          var _nextLayerAnimation = _objectSpread(_objectSpread({}, layerAnimation), {}, {
            // Create a new transition
            transition: _objectSpread(_objectSpread({}, _utils.DEFAULT_ANIMATION.transition), {}, {
              type: 'crossfade'
            }),
            // Copy previous animation exit setting(s)
            exit: _objectSpread(_objectSpread({}, layerAnimation === null || layerAnimation === void 0 ? void 0 : layerAnimation.exit), layerAnimation === null || layerAnimation === void 0 ? void 0 : layerAnimation.animate)
          });
          nextSoloSource.layer.animation = _nextLayerAnimation;
          nextScene = (0, _animationUtils.replaceSource)(nextScene, nextSoloSource._id, nextSoloSource);
        }
      }
    }
    // Current scene is featured media or screen
    if ((0, _animationUtils.isFeaturedMediaOrScreen)(currentScene)) {
      // If current scene has one camera presenter and next scene is solo camera presenter
      if ((0, _animationUtils.hasOneCameraPresenter)(currentScene) && (0, _animationUtils.isSoloCameraPresenter)(nextScene)) {
        var nextCameraPresenter = (0, _animationUtils.findSourceByType)(nextScene, _Sources.CAMERA_PRESENTER);
        var currentCameraPresenter = (0, _animationUtils.findSourceByType)(currentScene, _Sources.CAMERA_PRESENTER);
        if (!(0, _animationUtils.isSameSource)(nextCameraPresenter, currentCameraPresenter)) {
          nextCameraPresenter.layer.animation.initial = {
            left: -_utils.SCENE_WIDTH
          };
          nextCameraPresenter.layer.animation.transition = _utils.DEFAULT_ANIMATION.transition;
          return (0, _animationUtils.replaceSource)(nextScene, nextCameraPresenter._id, nextCameraPresenter);
        }
      }

      // The current scene has less than 5 camera presenters
      if ((0, _animationUtils.getSourceCountByType)(currentScene, _Sources.CAMERA_PRESENTER) < 5) {
        // The next scene is grid
        if ((0, _animationUtils.isSceneLayout)(nextScene, _SceneLayouts.GRID)) {
          // Enable presenter animations when we have less than 5 presenters
          return (0, _animationUtils.enablePresenterAnimations)(nextScene);
        }
      } else {
        /**
         * The current scene has more than 5 camera presenters
         * the next scene is featured media or screen
         */
        if ((0, _animationUtils.isFeaturedMediaOrScreen)(nextScene)) {
          // The current scene has 5 presenters and the next has 4 presenters
          if ((0, _animationUtils.getSourceCountByType)(currentScene, _Sources.CAMERA_PRESENTER) === 5 && (0, _animationUtils.getSourceCountByType)(nextScene, _Sources.CAMERA_PRESENTER) === 4) {
            // Cut into next scene - disable all animations
            return (0, _animationUtils.disableContentAnimations)(nextScene, [_Sources.CAMERA_PRESENTER, _Sources.IMAGE_FILE, _Sources.PDF_FILE, _Sources.VIDEO_FILE]);
          }
        }
      }
    }
    if ((0, _animationUtils.isFeaturedMediaOrScreen)(nextScene)) {
      if ((0, _animationUtils.getSourceCountByType)(nextScene, _Sources.CAMERA_PRESENTER) > 4) {
        var _nextFeaturedSource$l;
        /**
         * More than 4 camera presenters are rendered side by side
         * we don't want the slide from or to right animation - we disable it
         */
        var nextFeaturedSource = (0, _animationUtils.getFeaturedMediaOrScreen)(nextScene);
        var _layerAnimation = (nextFeaturedSource === null || nextFeaturedSource === void 0 || (_nextFeaturedSource$l = nextFeaturedSource.layer) === null || _nextFeaturedSource$l === void 0 ? void 0 : _nextFeaturedSource$l.animation) || {};
        _layerAnimation['transition'] = _utils.HARD_CUT_ANIMATION.transition;
        nextFeaturedSource.layer['animation'] = _layerAnimation;
        return (0, _animationUtils.replaceSource)(nextScene, nextFeaturedSource._id, nextFeaturedSource);
      } else {
        // Enable presenter animations when we have 4 or less presenters
        return (0, _animationUtils.enablePresenterAnimations)(nextScene);
      }
    }
  }
  return nextScene;
}

/**
 * Apply global animations on the next scene indiscriminately.
 * Note that this might override some animations by applyTargetedAnimations()
 * method but the product team is happy :)
 * @param {{}} nextScene
 */
function applyGlobalAnimations(nextScene) {
  // Apply smooth easing animation
  var nextSceneLayers = (0, _utils.getProgramLayers)(nextScene);
  var updatedLayers = nextSceneLayers.map(function (layerItem) {
    var _layerItem$layer = layerItem.layer,
      layerSource = _layerItem$layer === void 0 ? {} : _layerItem$layer,
      source = layerItem.source;
    var layerAnimation = layerSource.animation,
      _layerSource$style = layerSource.style,
      layerStyle = _layerSource$style === void 0 ? {} : _layerSource$style;
    var _layerStyle$mediaStyl = layerStyle.mediaStyle,
      mediaStyle = _layerStyle$mediaStyl === void 0 ? {} : _layerStyle$mediaStyl;
    if (!!layerAnimation) {
      var _layerAnimation$trans;
      var objectFitStyle = mediaStyle.objectFit;
      var omitObjectFitStyle = (0, _animationUtils.isSceneLayout)(nextScene, [_SceneLayouts.GRID.id, _SceneLayouts.SIDE_BY_SIDE.id]);

      // Preserve instant transition (duration: 0) for media assets to prevent flicker
      var sourceType = source === null || source === void 0 ? void 0 : source.type;
      var isMedia = [_Sources.IMAGE_FILE, _Sources.PDF_FILE, _Sources.VIDEO_FILE].includes(sourceType);
      var shouldPreserveInstantTransition = isMedia && (layerAnimation === null || layerAnimation === void 0 || (_layerAnimation$trans = layerAnimation.transition) === null || _layerAnimation$trans === void 0 ? void 0 : _layerAnimation$trans.duration) === 0;
      return _objectSpread(_objectSpread({}, layerItem), {}, {
        layer: _objectSpread(_objectSpread({}, layerSource), {}, {
          animation: _objectSpread(_objectSpread({}, layerAnimation), {}, {
            transition: shouldPreserveInstantTransition ? layerAnimation.transition // Keep duration: 0 for media assets
            : {
              delay: 0.0,
              duration: 0.35,
              ease: 'easeIn'
            },
            exit: {
              opacity: 0,
              transition: {
                ease: 'easeOut',
                duration: 0.35
              }
            }
          }),
          style: _objectSpread(_objectSpread({}, layerStyle), {}, {
            mediaStyle: {
              width: 'inherit',
              height: 'inherit',
              // Retain object-fit style if it is set, else default to cover
              objectFit: objectFitStyle && !omitObjectFitStyle ? objectFitStyle : 'cover'
            }
          })
        })
      });
    }
    return layerItem;
  });
  return !(0, _underscore.isEmpty)(nextScene) && _objectSpread(_objectSpread({}, nextScene), {}, {
    layers: updatedLayers
  }) || nextScene;
}

/**
 * @param {{}} currentScene
 * @param {{}} nextScene
 */
function applyAnimations(currentScene, nextScene) {
  var scene = applyTargetedAnimations(currentScene, nextScene);
  return applyGlobalAnimations(scene);
}